import { Injectable } from '@angular/core';
import type { Map, MapOptions, Marker, MarkerOptions } from 'mapbox-gl';

const MAPBOX_WORKER_URL = '/assets/mapbox/mapbox-gl-csp-worker.js';

export interface MapboxRuntime {
  createMap(options: MapOptions): Map;
  createMarker(options: MarkerOptions): Marker;
}

@Injectable({ providedIn: 'root' })
export class MapboxMapFactory {
  async load(): Promise<MapboxRuntime> {
    const mapboxgl = await import('mapbox-gl');
    mapboxgl.default.workerUrl = MAPBOX_WORKER_URL;

    return {
      createMap: options => {
        mapboxgl.default.accessToken = options.accessToken ?? '';
        return new mapboxgl.Map(options);
      },
      createMarker: options => new mapboxgl.Marker(options)
    };
  }
}
